export enum SCREEN_TYPE {
	MOBILE = 'MOBILE',
	TABLET = 'TABLET',
	DESKTOP = 'DESKTOP',
}

export enum TABS {
	PAYMENTS = 'payments',
	REDEMPTIONS = 'redemptions',
	ALL = 'all',
	DEALS = 'deals',
	PRIVILEGES = 'privileges',
}

export enum CONTACT_US_TYPES {
	MERCHANT = 'Merchant Enquiries',
	CUSTOMER = 'Customer Enquiries',
}

export const SCREEN_SIZE = {
	[SCREEN_TYPE.MOBILE]: 375,
	[SCREEN_TYPE.TABLET]: 576,
	[SCREEN_TYPE.DESKTOP]: 1400,
};

export const SCREEN_SIZE_QUERY = {
	[SCREEN_TYPE.MOBILE]: `(max-width: 575px)`,
	[SCREEN_TYPE.TABLET]: `(min-width: 576px) and (max-width: 1399px)`,
	[SCREEN_TYPE.DESKTOP]: `(min-width: 1400px)`,
};

export enum CURRENCY {
	SGD = 'SGD',
	AUD = 'AUD',
}

export enum COUNTRY_CODE {
	SG = 'SG',
	AU = 'AU',
}

export enum DEAL_PRIVILEGE {
	DEAL = 'deal',
	PRIVILEGE = 'privilege',
}

export const ENV = {
	LOCAL: 'local',
	DEV: 'dev',
	STAGING: 'stg',
	PROD: 'prod',
	UAT: 'uat',
};

export const MILES_CONVERSION_RATE = 0.00666667;

export const ERROR_MESSSAGES = {
	NO_DATA: 'No data found',
	NO_TRANSACTIONS: 'No transactions found',
	NO_REDEMPTIONS: 'No redemptions found',
	NO_DEALS: 'No deals found',
	NO_PRIVILEGES: 'No privileges found',
	FIREBASE_ANALYTICS_NOT_INITIALIZED: 'Firebase analytics not initialized',
	INIT_FIREBASE_FAILED: 'Error initializing App Insights and Firebase:',
	SERVICE_DOWN: {
		TITLE: 'Oops',
		DESCRIPTION: 'Kris+ Cashier is currently experiencing some technical difficulties.',
		SUB_DESCRIPTION: 'Please try again later.',
		BTN_TEXT: 'Go back',
	},
	NO_INTERNET_CONNECTION: {
		TITLE: 'No internet connection',
		DESCRIPTION: 'Please make sure your device is connected to the internet and try again.',
		BTN_TEXT: 'Try again',
	},
	SUBMIT_MERCHANT_REF_ID_FAILED: {
		TITLE: 'We are unable to complete your request right now',
		BTN_TEXT: 'Go back Home',
	},
};

export const KRIS_CONTACT_CUSTOMER_EMAIL = 'KrisPlus_Contact@singaporeair.com.sg';